import React from "react";
import Fontstyling from "../comman";

const CustomButton = ({
  className,
  style,
  type,
  Ref,
  onClick,
  onChange,
  children,
}) => {
  style ||= {
    ...Fontstyling.addnewbutton,
  };
  className ||= "me-3 text-nowrap";
  return (
    <button
      className={className}
      style={style}
      type={type}
      ref={Ref}
      onClick={onClick}
      onChange={onChange}
    >
      {children}
    </button>
  );
};

export default CustomButton;
